import axios from 'axios';

const updateConversationAssistantOpenedCountUserUIState = async (newCount: number) => {
  axios.put(
    '/admin/ui_states',
    { ui_state: { attribute: 'conversation_assistant_opened_count', value: newCount } },
    {
      responseType: 'json',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content'),
      },
    },
  );
};

export default updateConversationAssistantOpenedCountUserUIState;
